// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Skkv","title":"styles_title__2nrYb"};